import React, { Fragment, useState } from 'react';
import ProductListView from '../../../components/inventory/reports/product_list/ProductListView';
import AppURL from '../../../constants/AppURL';
import useFetchData from '../../../helpers/useFetch';

const InventoryProductListView = () => {
    const [onURL, setOnURL] = useState(AppURL.InventoryURL + 'inventory/product/item/create/list/view/');
    const { data, loading, error, refetch } = useFetchData(onURL);

    const handleFormSuccess = (): void => {
        refetch();
    };
  return (
    <Fragment>
        <ProductListView setOnURL={setOnURL} handleFormSuccess={handleFormSuccess} results={data} loading={loading} error={error} />
    </Fragment>
  )
}

export default InventoryProductListView